import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en_US from './translations/en-US/common.json'
import es_ES from './translations/es-ES/common.json'
import fr_FR from './translations/fr-FR/common.json'
import ja_JP from './translations/ja-JP/common.json'
import nl_NL from './translations/nl-NL/common.json'
import it_IT from './translations/it-IT/common.json'
import de_DE from './translations/de-DE/common.json'

i18n
.use(Backend)
.use(LanguageDetector)
.use(initReactI18next)

// for all options read: https://www.i18next.com/overview/configuration-options
.init({
  debug: true,
  fallbackLng: 'en-US',
  initImmediate: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  ns: ['common'],
  defaultNS: 'common',
  lng: 'en-US',
  resources: {
    'en-US': {
      common: en_US
    },
    'es-ES': {
      common: es_ES
    },
    'fr-FR': {
      common: fr_FR
    },
    'ja-JP': {
      common: ja_JP
    },
    'nl-NL': {
      common: nl_NL
    },
    'it-IT': {
      common: it_IT
    },
    'de-DE': {
      common: de_DE
    }
  }
}).then();

export default i18n;